import itIcon from '../../assets/images/icons/industriesIcons/it.svg';
import marketingIcon from '../../assets/images/icons/industriesIcons/marketing.svg';
import educationIcon from '../../assets/images/icons/industriesIcons/education.svg';
import managementIcon from '../../assets/images/icons/industriesIcons/management.svg';
import financeIcon from '../../assets/images/icons/industriesIcons/finance.svg';
import customercareIcon from '../../assets/images/icons/industriesIcons/customercare.svg';
import supervisorsIcon from '../../assets/images/icons/industriesIcons/supervisors.svg';
import hrIcon from '../../assets/images/icons/industriesIcons/hr.svg';
import legalIcon from '../../assets/images/icons/industriesIcons/legal.svg';
import healthcareIcon from '../../assets/images/icons/industriesIcons/healthcare.svg';
import securityIcon from '../../assets/images/icons/industriesIcons/security.svg';
import logisticsIcon from '../../assets/images/icons/industriesIcons/logistics.svg';
import creativeIcon from '../../assets/images/icons/industriesIcons/creative.svg';
import hotelsIcon from '../../assets/images/icons/industriesIcons/hotels.svg';
import operativeIcon from '../../assets/images/icons/industriesIcons/operative.svg';

import {useEffect, useMemo, useState} from "react";
import ReactPaginate from "react-paginate";
import B2BApiService from "../../B2bApiService";
import { t, getIndustryTitle } from '../../content';
import { useLocale } from '../../locale';

function OpenPosition ({ selectedPositionId, onSelectedFunction, poolList }) {
    const { locale } = useLocale();
    const b2bServiceObj = useMemo(() => {
        return new B2BApiService();
    }, []);

    let [positionsData, setPositionsData] = useState([]);
    const [pageNumber, setPageNumber] = useState(0);
    const [selectedId, setSelectedId] = useState(0);
    const itemsPerPage = 10;
    const pagesVisited = pageNumber * itemsPerPage;


    const pageCount = Math.ceil(positionsData.length / itemsPerPage);
    const changePage = ({ selected }) => {
        setPageNumber(selected);
    }

    useEffect(() => {
        setPositionsData(poolList);
        if (selectedPositionId) {
            setSelectedId(selectedPositionId);
            b2bServiceObj.LoadPoolByHash(selectedPositionId)
        }else {
            setSelectedId(poolList[0].hash);
        }
    }, [poolList, b2bServiceObj, selectedPositionId]);

    const onPoolChange = (hash) => {
        setSelectedId(hash);
        onSelectedFunction(hash);
    }

    const displayItems = positionsData.slice(pagesVisited, pagesVisited + itemsPerPage).map((position, index) => {
        let fullDate = new Date(position.deadline)
        if (position.deadline) {
            const options = { month: 'short', year: 'numeric', day: 'numeric' };
            var formatedDate = fullDate.toLocaleDateString('en-us', options).replaceAll(',', '');
        }
        else {
            formatedDate = "Open"
        }
        const currentDate = new Date();
        
        return (
            <button
                id={position.id}
                className={selectedId === position.hash ? 'open-position active' : 'open-position'}
                key={index}
                onClick={() => onPoolChange(position.hash)}
            >
                <div className={`position-status ${fullDate < currentDate ? 'inactive' : 'active'}`}>
                    {position.industry.id === 1 && <img src={itIcon} alt={getIndustryTitle(1, locale)} />}
                    {position.industry.id === 2 && <img src={marketingIcon} alt={getIndustryTitle(2, locale)} />}
                    {position.industry.id === 3 && <img src={educationIcon} alt={getIndustryTitle(3, locale)} />}
                    {position.industry.id === 4 && <img src={managementIcon} alt={getIndustryTitle(4, locale)} />}
                    {position.industry.id === 5 && <img src={financeIcon} alt={getIndustryTitle(5, locale)} />}
                    {position.industry.id === 6 && <img src={customercareIcon} alt={getIndustryTitle(6, locale)} />}
                    {position.industry.id === 7 && <img src={supervisorsIcon} alt={getIndustryTitle(7, locale)} />}
                    {position.industry.id === 8 && <img src={hrIcon} alt={getIndustryTitle(8, locale)} />}
                    {position.industry.id === 9 && <img src={legalIcon} alt={getIndustryTitle(9, locale)} />}
                    {position.industry.id === 10 && <img src={healthcareIcon} alt={getIndustryTitle(10, locale)} />}
                    {position.industry.id === 11 && <img src={securityIcon} alt={getIndustryTitle(11, locale)} />}
                    {position.industry.id === 12 && <img src={logisticsIcon} alt={getIndustryTitle(12, locale)} />}
                    {position.industry.id === 13 && <img src={creativeIcon} alt={getIndustryTitle(13, locale)} />}
                    {position.industry.id === 14 && <img src={hotelsIcon} alt={getIndustryTitle(14, locale)} />}
                    {position.industry.id === 15 && <img src={operativeIcon} alt={getIndustryTitle(15, locale)} />}
                </div>
                <div className="position-desctription">
                    <p className="position-title m-0 bold m">{position.title}</p>
                    <p className="position-industry m-0 light">{getIndustryTitle(position.industry, locale)}</p>
                </div>
                <div className="mazhr-card-filled-candidates">
                    <p className="light m-0">{t('recruitment.candidateCount', { count: position.userCount })}</p>
                </div>
                <div className="deadline">
                    <div>
                        <p className="light m-0">{formatedDate}</p>
                    </div>
                </div>
            </button>
        )
    });

    return (
        <div id="top" className="position-items">
            <div className="position-items-wrapper">
                {displayItems}
            </div>
            {displayItems.length > 1 &&
                <ReactPaginate
                    previousLabel={"PREV"}
                    nextLabel={"NEXT"}
                    pageCount={pageCount}
                    onPageChange={changePage}
                    containerClassName={"pagination"}
                    previousLinkClassName={"prevBtn"}
                    nextLinkClassName={"nextBtn"}
                    disabledClassName={"paginationDisabled"}
                    activeClassName={"paginationActive"}
                    pageClassName={"pagination-item"}
                />
            }
        </div>
    )
}

export default OpenPosition;

